/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable no-return-assign */
import { useCallback, useMemo, useState } from 'react';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import {
  DataGrid,
  DataGridProps,
  esES,
  enUS,
  GridColumns,
  GridColumnVisibilityModel
} from '@mui/x-data-grid';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router';
import EmojiFlagsIcon from '@mui/icons-material/EmojiFlags';
import Schema from '@mui/icons-material/Schema';
import { ReactFlowProvider } from 'reactflow';
import { useTranslation } from 'react-i18next';

import { StatusCode } from 'helpers/app.config';
import { getDateUTCformatWhenDateIsProgrammed } from 'helpers/utils';
import GanttModal from 'pages/Ticket/Crud/components/GanttModal';
import useGetCookie from 'hooks/useGetCookie';
import useGetClientStatusList from 'hooks/client/useGetClientStatusList';

import { OrganizeStatusCode } from '../TicketsDataGridHeader';
import {
  columnVisibilityModel,
  headerToExport,
  headerToExportHistoric,
  headerToExportProgramedColumns,
  staticColums
} from './columns';
import DataGridPagination from '../DataGridPagination';
import { TicketSearched } from '../../../api/ticket';
import { CustomToolbar } from '../CatalogDataGrid/CustomToolbar';
import { TFormat, TOption, TypeButtons } from '../ExportOptions';
import ExpandCommentCell from '../ExpandCommentCell';
import GenericModal from '../GenericModal';
import ActionsTable from '../ActionsTableIcons';

type Props = Partial<DataGridProps> & {
  clearSelectedTickets?: () => void;
  filterButton?: TypeButtons;
  itemsToExport: { [key: string]: unknown }[];
  onExport: (selectedOption: TOption) => void;
  organizeStatus?: number;
  returnColumns?: GridColumnVisibilityModel;
  rows?: TicketSearched[];
  selectedTickets?: TicketSearched[];
  setReturnColumns?: React.Dispatch<
    React.SetStateAction<GridColumnVisibilityModel>
  >;
  exportOption?: TFormat;
  setExportOption?: React.Dispatch<React.SetStateAction<TFormat>>;
  handleUploadFile: ({
    fileContent,
    fileName,
    description
  }: {
    fileContent: string;
    fileName: string;
    description: string;
  }) => void;
  isGeneratingReport: boolean;
};

export interface Density {
  value: string;
  headerHeight: number;
  rowHeight: number;
  factor: number;
}

export default function TicketsDataGrid({
  clearSelectedTickets,
  filterButton,
  itemsToExport,
  onExport,
  organizeStatus,
  returnColumns,
  rows,
  selectedTickets,
  setReturnColumns,
  exportOption,
  setExportOption,
  handleUploadFile,
  isGeneratingReport,
  ...props
}: Props) {
  const navigate = useNavigate();
  const [densityState, setDensity] = useState<Density>();
  const [showCommentDialogData, setShowCommentDialogData] = useState<{
    open: boolean;
    message?: string;
    id?: number;
    title?: string;
  }>({
    open: false,
    message: undefined,
    id: undefined,
    title: undefined
  });
  const [showCommentDialogDataNumber, setShowCommentDialogDataNumber] =
    useState<{
      open: boolean;
      message?: string;
      id?: number;
      title?: string;
    }>({
      open: false,
      message: undefined,
      id: undefined,
      title: undefined
    });

  const { t, i18n } = useTranslation('global');
  const { statusList } = useGetClientStatusList();

  const [openGantt, setOpenGantt] = useState<{
    workFlowOrderId: number | string;
    workFlowOrderName: string;
  }>(null);
  /* get cookie */
  const columnVisibilityModelFromCookie = useGetCookie(
    'columnVisibilityModelTickets'
  );
  /* get cookie */

  const statusHistorical = rows.some(
    (data: { statusId: number }) => data.statusId === StatusCode.Historic
  );
  const statusCancel = rows.some(
    (data: { statusId: number }) => data.statusId === StatusCode.Cancelled
  );
  const statusProgrammed = rows.length
    ? rows.every(
        (data: { statusId: number }) => data.statusId === StatusCode.Programmed
      )
    : false;
  const statusHistoricForExport = selectedTickets.some(
    (data: { statusId: number }) => data.statusId === StatusCode.Historic
  );

  const rowStateColors =
    statusList?.reduce(
      (acc, status) => ({
        ...acc,
        [`& .MuiDataGrid-row.Status-${status.id}`]: {
          borderColor: status.hexColor
        }
      }),
      {}
    ) || {};

  const nameToExport = () => {
    switch (organizeStatus) {
      case OrganizeStatusCode.Active:
        return `_${t('ticket.statusOption.active')}`;
      case OrganizeStatusCode.Historic:
        return `_${t('ticket.statusOption.active')}`;
      case OrganizeStatusCode.Cancelled:
        return `_${t('ticket.statusOption.cancelled')}`;
      case OrganizeStatusCode.Custom:
        return `_${t('ticket.statusOption.personalized')}`;
      case OrganizeStatusCode.Programmed:
        return `_${t('ticket.statusOption.programmed')}`;
      default:
        return '';
    }
  };

  const handleOpenShowComment = useCallback(
    (id: number, message: string, title: string) => {
      setShowCommentDialogData({
        open: true,
        id,
        message,
        title
      });
    },
    []
  );

  const handleOpenShowCommentAlerted = useCallback(
    (id: number, message: string, title: string) => {
      setShowCommentDialogDataNumber({
        open: true,
        id,
        message,
        title
      });
    },
    []
  );

  const programedColumns: GridColumns<TicketSearched> = [
    {
      field: '__check__',
      headerName: 'common.commonProperties.boxSelection',
      maxWidth: 80,
      minWidth: 40,
      flex: 1,
      sortable: false
    },
    {
      field: 'ticketId',
      headerName: 'common.commonProperties.ticketNumber',
      renderCell: ({ row }) => (
        <Typography
          onClick={() =>
            row?.statusId !== StatusCode.Programmed &&
            navigate(`/requirement/detail/${row?.ticketId}/general`)
          }
          sx={{
            textDecoration:
              row?.statusId !== StatusCode.Programmed && 'underline',
            cursor: row?.statusId !== StatusCode.Programmed && 'pointer',
            color: row?.ticketProgress === 100.0 ? '#eb0400' : '#0B2E6A',
            '&:hover': {
              fontWeight: 500
            }
          }}
        >
          {row?.ticketProgress === 100.0 ? (
            <Tooltip placement="top" title={t('ticket.messages.timeHasGone')}>
              <Typography>{row?.ticketId}</Typography>
            </Tooltip>
          ) : (
            <Typography>{row?.ticketId}</Typography>
          )}
        </Typography>
      )
    },
    {
      field: 'statusName',
      headerName: 'common.commonProperties.ticketStatus',
      minWidth: 125,
      flex: 1
    },
    {
      field: 'clientName',
      headerName: 'common.commonProperties.client',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'projectName',
      headerName: 'common.commonProperties.project',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'locationName',
      headerName: 'common.commonProperties.ubication',
      minWidth: 100,
      maxWidth: 130,
      flex: 1
    },
    {
      field: 'serviceTypeName',
      headerName: 'common.commonProperties.serviceType',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'serviceName',
      headerName: 'common.commonProperties.serviceSingular',
      minWidth: 100,
      flex: 1
    },
    {
      field: 'assignedEngineerFullName',
      headerName: 'common.commonProperties.taskForce',
      minWidth: 300,
      flex: 1
    },
    {
      field: 'tasksDescription',
      headerName: 'common.commonProperties.descriptionActivities',
      minWidth: 100,
      maxWidth: 150,
      flex: 1,
      renderCell: ({ row }) => (
        <ExpandCommentCell
          dialog={showCommentDialogData}
          expandComment={handleOpenShowComment}
          id={row?.ticketId}
          message={row?.tasksDescription}
          title={t('common.commonProperties.descriptionActivities')}
          megaComent
        />
      )
    },
    {
      field: 'startDate',
      headerName: 'common.commonProperties.startProgrammedDate',
      flex: 1,
      minWidth: 150,
      valueFormatter: (params: { value: string }) =>
        getDateUTCformatWhenDateIsProgrammed(params?.value)
    }
  ];

  const handleCloseShowComment = useCallback(() => {
    setShowCommentDialogData({
      open: false,
      message: undefined,
      id: undefined,
      title: undefined
    });
    setShowCommentDialogDataNumber({
      open: false,
      message: undefined,
      id: undefined,
      title: undefined
    });
  }, []);

  const columnsRequiredToRender: GridColumns<TicketSearched> =
    organizeStatus === OrganizeStatusCode.Programmed || statusProgrammed
      ? programedColumns
      : [
          {
            field: '__check__',
            headerName: 'common.commonProperties.boxSelection',
            maxWidth: 80,
            minWidth: 40,
            flex: 1,
            sortable: false
          },
          {
            field: 'ticketId',
            headerName: 'common.commonProperties.ticketNumber',
            renderCell: ({ row }) => (
              <Typography
                onClick={() => {
                  navigate(`/requirement/detail/${row?.ticketId}/general`);
                }}
                sx={{
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  color: row?.ticketProgress === 100.0 ? '#eb0400' : '#0B2E6A',
                  '&:hover': {
                    fontWeight: 500
                  }
                }}
              >
                {row?.ticketProgress === 100.0 ? (
                  <Tooltip
                    placement="top"
                    title={t('ticket.messages.timeHasGone')}
                  >
                    <Typography>{row?.ticketId}</Typography>
                  </Tooltip>
                ) : (
                  <Typography>{row?.ticketId}</Typography>
                )}
              </Typography>
            )
          },
          ...staticColums,
          {
            field: 'requestedByUser',
            headerName: 'common.commonProperties.requestedBy',
            minWidth: 100,
            flex: 1,
            renderCell: ({ row }) =>
              row?.requestedByUser ? row?.requestedByUser : row?.requesterEmail
          },
          {
            field: 'tasksDescription',
            headerName: 'common.commonProperties.descriptionActivities',
            minWidth: 100,
            maxWidth: 150,
            flex: 1,
            renderCell: ({ row }) => (
              <ExpandCommentCell
                dialog={showCommentDialogData}
                expandComment={handleOpenShowComment}
                id={row?.ticketId}
                message={row?.tasksDescription}
                title={t('common.commonProperties.descriptionActivities')}
                megaComent
              />
            )
          },
          {
            field: 'ticketDelayClassificationName',
            headerName: 'common.commonProperties.delayTicketName',
            minWidth: 110,
            maxWidth: 170,
            flex: 1
          },
          {
            field: 'closedDate',
            headerName: 'common.commonProperties.closedDate',
            flex: 1,
            minWidth: 100,
            valueFormatter: (params: { value: string }) =>
              params?.value
                ? dayjs.utc(params.value).local().format('DD-MM-YYYY HH:mm')
                : ''
          },
          {
            field: 'startDate',
            headerName: 'common.commonProperties.startProgrammedDate',
            flex: 1,
            minWidth: 100,
            valueFormatter: (params: { value: string }) =>
              params?.value
                ? dayjs.utc(params.value).local().format('DD-MM-YYYY HH:mm')
                : ''
          },
          {
            field: 'firstCallSolution',
            headerName: 'common.commonProperties.firstCallSolution',
            flex: 1,
            minWidth: 100
          },
          {
            field: 'scheduledDate',
            headerName: 'common.commonProperties.dueDate',
            flex: 1,
            minWidth: 100,
            valueFormatter: (params: { value: string }) =>
              params?.value
                ? dayjs.utc(params.value).local().format('DD-MM-YYYY HH:mm')
                : ''
          },
          {
            field: 'ticketProgress',
            headerName: 'common.commonProperties.followUp',
            flex: 1,
            minWidth: 100,
            renderCell: (data: { row: TicketSearched }) => {
              const indicatorHexColor = data?.row?.flags?.indicatorHexColor;
              const ticketProgress = data?.row?.flags?.ticketProgress;

              return (
                <>
                  <EmojiFlagsIcon
                    sx={{
                      color: indicatorHexColor || '#000000'
                    }}
                  />
                  <span>
                    {Number(ticketProgress) > 0
                      ? `${parseFloat(ticketProgress).toFixed(2)}%`
                      : '0%'}
                  </span>
                </>
              );
            }
          }
        ];

  const columns: GridColumns<TicketSearched> = useMemo(() => {
    const columnsFormatted = columnsRequiredToRender
      .concat([
        {
          field: 'ticketCloseFields',
          headerName: 'common.commonProperties.requiredFields',
          flex: 1,
          minWidth: 200,
          renderCell: ({ row }) => (
            <ExpandCommentCell
              dialog={showCommentDialogData}
              expandComment={handleOpenShowComment}
              id={row?.ticketId}
              message={
                row?.ticketCloseFields
                  ?.split('\n')
                  ?.map((item) => `${item}`)
                  ?.filter((item) => item !== '')
                  ?.join('\r') || t('ticket.messages.withoutFields')
              }
              title={t('common.commonProperties.requiredFields')}
            />
          )
        },
        {
          field: 'externalOrigin',
          headerName: 'common.commonProperties.externalOrigin',
          flex: 1,
          minWidth: 200
        },
        {
          field: 'externalEventId',
          headerName: 'common.commonProperties.externalEventId',
          flex: 1,
          minWidth: 200,
          renderCell: ({ row }) => (
            <ExpandCommentCell
              dialog={showCommentDialogDataNumber}
              expandComment={handleOpenShowCommentAlerted}
              id={row?.ticketId}
              message={
                String(row?.externalEventId)?.split(',').join(', ') || ''
              }
              title={t('common.commonProperties.externalEventId')}
            />
          )
        },
        {
          field: 'interventionCode',
          headerName: 'ticket.ticketDetail.interventionCode',
          flex: 1,
          minWidth: 200,
          renderCell: ({ row }) => (
            <ExpandCommentCell
              dialog={showCommentDialogData}
              expandComment={handleOpenShowComment}
              id={row?.ticketId}
              message={row?.interventionCodeName?.split(',')?.join('\r') || ''}
              title={t('ticket.ticketDetail.interventionCode')}
            />
          )
        },
        {
          field: 'flags',
          headerName: 'common.commonProperties.lifeCycle',
          flex: 1,
          minWidth: 200,
          renderCell: ({ row }) => (
            <ExpandCommentCell
              dialog={showCommentDialogData}
              expandComment={handleOpenShowComment}
              id={row?.ticketId}
              message={row?.flags?.steps
                ?.map(
                  (item) =>
                    `${
                      statusList?.find((status) => status.id === item.statusId)
                        ?.name
                    },
                      ${item.percent.toFixed(2)}%`
                )
                .join('\r')}
              title={t('common.commonProperties.lifeCycle')}
            />
          )
        },
        {
          field: 'actions',
          headerName: 'common.commonProperties.actions',
          headerAlign: 'center',
          align: 'center',
          renderCell: (renderCellParams) => (
            <ActionsTable>
              {renderCellParams?.row?.ticketClientGroup && (
                <Tooltip title={t('common.commonProperties.ganttDiagram')}>
                  <IconButton
                    onClick={() =>
                      setOpenGantt({
                        workFlowOrderId:
                          renderCellParams?.row?.ticketClientGroup,
                        workFlowOrderName: renderCellParams?.row?.workFlowName
                      })
                    }
                    size="small"
                  >
                    <Schema />
                  </IconButton>
                </Tooltip>
              )}
            </ActionsTable>
          ),
          flex: 1,
          minWidth: 100,
          sortable: false
        }
      ])
      .map((column) => {
        const newColumn = column;
        // Con esto reviso si la columna esta en el objeto de columnas a retornar
        // Para que no aparezca en el excel
        newColumn.disableExport =
          !Object.prototype.hasOwnProperty.call(returnColumns, column.field) ||
          returnColumns[column.field] === false;

        return newColumn;
      });

    const columnsWithPartnerName = [
      ...columnsFormatted.slice(0, 3),
      {
        field: 'partnerName',
        headerName: 'common.commonProperties.partnerSingular',
        headerAlign: 'center',
        align: 'center',
        flex: 1,
        minWidth: 100,
        renderCell: ({ row }: { row: { id?: number; partnerName?: string } }) =>
          row?.partnerName ? (
            <ExpandCommentCell
              dialog={showCommentDialogData}
              expandComment={handleOpenShowComment}
              id={row?.id}
              message={row?.partnerName?.split(' ').join('\r')}
              title={t('common.commonProperties.partnerSingular')}
            />
          ) : (
            '-'
          )
      },
      ...columnsFormatted.slice(3)
    ];

    return columnsWithPartnerName;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [columnsRequiredToRender, returnColumns]);

  /*
  Se comenta para validación de programados
  */
  const changeColumnVisibilityModel = (newModel: GridColumnVisibilityModel) => {
    // Limpia la selección de tickets
    clearSelectedTickets();

    // Crea una copia del modelo de visibilidad desde la cookie para evitar mutaciones directas
    const cookieModel = { ...columnVisibilityModelFromCookie };

    // Condición para cuando solo hay 3 columnas seleccionadas y son las específicas
    const isThreeSpecificColumns =
      Object.keys(newModel).length === 3 &&
      newModel.comunicationAdvanceSolution &&
      newModel.steps &&
      newModel.creationDateUTC &&
      Object.values(newModel).every((value) => value === true);

    if (isThreeSpecificColumns) {
      // Si se cumplen las condiciones, activa todas las columnas
      Object.keys(cookieModel).forEach((key) => {
        cookieModel[key] = true;
      });
      setReturnColumns?.(cookieModel);
      return;
    }

    // Si el estado es "Programmed", combina el modelo de la cookie con el nuevo modelo
    if (organizeStatus === OrganizeStatusCode.Programmed) {
      setReturnColumns?.({
        ...cookieModel,
        ...newModel
      });
      return;
    }

    // Para otros casos, filtra solo las columnas activas
    const modelFiltered = Object.fromEntries(
      Object.entries(newModel).filter(([, value]) => value)
    );

    // Si las 3 columnas específicas están activas, combina el modelo de la cookie con el nuevo modelo
    if (
      Object.keys(modelFiltered).length === 3 &&
      modelFiltered.comunicationAdvanceSolution &&
      modelFiltered.steps &&
      modelFiltered.creationDateUTC
    ) {
      setReturnColumns?.({
        ...cookieModel,
        ...newModel
      });
      return;
    }

    // Actualiza el modelo de columnas retornadas con las columnas activas
    setReturnColumns?.((prevColumns) => ({
      ...prevColumns,
      ...modelFiltered
    }));
  };

  const setActiveCookie = (event: Record<string, boolean>) => {
    const updatedVisibilityModel = { ...columnVisibilityModel, ...event };
    const jsonString = JSON.stringify(updatedVisibilityModel);

    document.cookie = `columnVisibilityModelTickets=${jsonString}; path=/; max-age=31536000;`;
  };

  const headerToRender = useMemo(() => {
    let headers =
      // eslint-disable-next-line no-nested-ternary
      organizeStatus === OrganizeStatusCode.Programmed
        ? headerToExportProgramedColumns
        : (
            selectedTickets.length > 0
              ? selectedTickets.some(
                  (ticket) =>
                    ticket.statusId === StatusCode.Historic ||
                    ticket.statusId === StatusCode.Closed
                )
              : rows.some(
                  (ticket) =>
                    ticket.statusId === StatusCode.Historic ||
                    ticket.statusId === StatusCode.Closed
                )
          )
        ? headerToExportHistoric
        : headerToExport;

    if (exportOption === 'PDF') {
      headers = headers?.filter(
        (header) => header?.key !== 'comunicationAdvanceSolution'
      );
    }

    return headers
      .filter((header) => returnColumns[header.key])
      .concat(
        organizeStatus !== OrganizeStatusCode.Programmed &&
          exportOption !== 'PDF'
          ? statusList?.map((status) => ({
              key: `status-${status?.id}`,
              label: status?.name
            }))
          : []
      );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    organizeStatus,
    statusProgrammed,
    statusHistorical,
    statusCancel,
    exportOption,
    returnColumns,
    statusHistoricForExport
  ]);

  const NoRowsOverlay = useCallback(
    () => (
      <Typography
        align="center"
        component="div"
        height="100%"
        paddingTop={30}
        sx={{
          fontWeight: 'normal',
          color: '#063468',
          fontSize: '14px'
        }}
        variant="h4"
        gutterBottom
      >
        {t('ticket.messages.noResults')}
      </Typography>
    ),
    []
  );

  function arrayToCSV(
    array: { Nombre?: string; Porcentaje?: string }[]
  ): string {
    // Check if the array is empty
    if (array?.length === 0) {
      return '';
    }
    // Get the keys of the first item in the array to use as column headers
    const headers = Object.keys(array[0])?.join(',');

    // Convert each item in the array to a CSV row
    const rowsItems = array
      .map((item) => Object.values(item)?.join(','))
      .join('\n');

    // Return the CSV string with headers and rowsItems
    return `${headers}\n${rowsItems}`;
  }

  const formatSelectedTicket = useMemo(() => {
    if (exportOption === 'PDF') {
      return selectedTickets.map((itemsPDF) => ({
        ...itemsPDF,
        comunicationAdvanceSolution: null
      }));
    }

    const newItemsSelected = selectedTickets
      ?.map((item) => ({
        ...item,
        steps: arrayToCSV(
          item?.flags?.steps?.map((step) => ({
            Nombre: statusList?.find((status) => status.id === step?.statusId)
              ?.name,
            Porcentaje: step.percent.toFixed(2)
          })) || []
        ),
        comunicationAdvanceSolution: item?.comunicationAdvanceSolution
          ?.map(
            (comunication) =>
              `${dayjs
                .utc(comunication?.createdDateTime)
                .local()
                .format('DD-MM-YYYY HH:mm')} - ${comunication?.comment}`
          )
          ?.join('\n')
      }))
      ?.map((item) => ({
        ...item,
        ...Object.keys(statusList).reduce((acc, statusId) => ({
          ...acc,
          [`status-${statusId}`]: item?.flags?.steps?.find(
            (step) => step?.statusId === Number(statusId)
          )
            ? `${
                item?.flags?.steps
                  ?.find((step) => step.statusId === Number(statusId))
                  ?.percent.toFixed(2) > '0.00'
                  ? item?.flags?.steps
                      ?.find((step) => step.statusId === Number(statusId))
                      ?.percent.toFixed(2)
                  : 0.01
              }%`
            : ' '
        }))
      }));

    return newItemsSelected;
  }, [exportOption, selectedTickets]);

  const handleStateChange = useCallback(
    ({ density }: { density: Density }) => {
      if (density.value !== densityState?.value) {
        setDensity(density);
      }
    },
    [densityState?.value]
  );

  const itemsToExportMemoizado = useMemo(
    () =>
      itemsToExport?.map((item: TicketSearched) =>
        exportOption !== 'PDF' &&
        organizeStatus !== OrganizeStatusCode.Programmed
          ? {
              ...item,
              ...Object.keys(statusList).reduce(
                (acc, statusId: number | string) => ({
                  ...acc,
                  [`status-${statusId}`]: item?.flags?.steps?.find(
                    (step) => step.statusId === Number(statusId)
                  )
                    ? `${item?.flags?.steps
                        ?.find((step) => step.statusId === Number(statusId))
                        ?.percent.toFixed(2)}%`
                    : ' '
                })
              ),
              comunicationAdvanceSolution: item?.comunicationAdvanceSolution
                ?.map(
                  (comunication) =>
                    `${dayjs
                      .utc(comunication?.createdDateTime)
                      .local()
                      .format('DD-MM-YYYY HH:mm')} - ${comunication?.comment}`
                )
                ?.join('\n')
            }
          : item
      ),
    [exportOption, itemsToExport, organizeStatus]
  );

  const densityStateStyle = (value: string) => {
    if (value === 'compact') return '0px 20px 0px 0px';
    if (value === 'standard') return '5px 20px 5px 0px';
    return '10px 20px 10px 0px';
  };

  return (
    <div style={{ display: 'flex', height: '100%', width: '100%' }}>
      <div style={{ flexGrow: 1 }}>
        {/* MODAL PARA LOS COMENTARIOS DE TEXTO PERO SON STRINGS */}
        <GenericModal
          bodyContent={
            <div>
              {showCommentDialogData.message?.split('\r').map((item, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>{item}</li>
              ))}
            </div>
          }
          dialogProps={{
            open: showCommentDialogData.open,
            title: showCommentDialogData?.title
          }}
          onCancelClickButton={handleCloseShowComment}
          hideButtonCancel
        />
        {/* MODAL PARA LOS COMENTARIOS DE TEXTO PERO SON NUMEROS */}
        <GenericModal
          bodyContent={
            <div>
              {showCommentDialogDataNumber.message
                ?.split(', ')
                .map((item, index) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <li key={index}>{item}</li>
                ))}
            </div>
          }
          dialogProps={{
            open: showCommentDialogDataNumber.open,
            title: showCommentDialogDataNumber?.title
          }}
          onCancelClickButton={handleCloseShowComment}
          hideButtonCancel
        />
        {!!openGantt && (
          <ReactFlowProvider>
            <GanttModal
              isOpen={!!openGantt}
              onClose={() => setOpenGantt(null)}
              workFlowOrder={openGantt}
            />
          </ReactFlowProvider>
        )}
        <DataGrid
          columns={columns.map((column) => ({
            ...column,
            headerName: t(column.headerName)
          }))}
          components={{
            Toolbar: CustomToolbar,
            LoadingOverlay: LinearProgress,
            Pagination: DataGridPagination,
            NoRowsOverlay
          }}
          componentsProps={{
            toolbar: {
              fileName: `Tickets${nameToExport()}`,
              filterButton,
              headerToExport: headerToRender.map((header) => ({
                ...header,
                label: t(header.label)
              })),
              isExport: true,
              isLandscapePDF: true,
              itemsSelectedToExport: formatSelectedTicket,
              itemsToExport: itemsToExportMemoizado,
              maximRowToExport: selectedTickets?.length || 15000,
              onExport,
              rowCount: props?.rowCount,
              limitCSVandXLSX: true,
              setExportOption,
              handleUploadFile,
              sendEmailBase64: true,
              isSendingEmail: isGeneratingReport
            }
          }}
          density="comfortable"
          getEstimatedRowHeight={() => 70}
          getRowClassName={(params: { row: { statusId: number } }) =>
            `Status-${params?.row?.statusId}`
          }
          getRowHeight={() => 'auto'}
          getRowId={({ ticketId }: { ticketId: number }) => ticketId}
          initialState={{
            columns: {
              columnVisibilityModel:
                columnVisibilityModelFromCookie || columnVisibilityModel
            }
          }}
          localeText={{
            ...(i18n.language === 'es'
              ? esES.components.MuiDataGrid.defaultProps.localeText
              : enUS.components.MuiDataGrid.defaultProps.localeText),
            toolbarDensityLabel: t('common.dataGrid.densityCompact'),
            toolbarDensityStandard: t('common.dataGrid.densityStandard'),
            toolbarDensityComfortable: t('common.dataGrid.densityComfortable')
          }}
          onColumnVisibilityModelChange={(newModel) => {
            changeColumnVisibilityModel(newModel);
            setActiveCookie(newModel);
          }}
          onStateChange={handleStateChange}
          paginationMode="server"
          rows={rows || []}
          rowsPerPageOptions={[25, 40, 60, 80, 100]}
          sx={{
            minHeight: '300px',
            '.MuiDataGrid-columnHeaderTitleContainer': {
              justifyContent: 'center'
            },
            textAlign: 'center',
            '.MuiDataGrid-columnHeaders': {
              backgroundColor: '#0B2E6A',
              minHeight: '39px',
              lineHeight: 'normal !important',
              color: 'white',
              '.MuiSvgIcon-root': {
                fill: 'white'
              },
              '.MuiIconButton-root': {
                padding: '0px 0px 0px 5px'
              }
            },
            '.MuiLinearProgress-root': {
              height: '8px'
            },
            '&.MuiDataGrid-root .MuiDataGrid-cell:focus': {
              outline: 'none'
            },
            '& .MuiDataGrid-row': {
              borderTop: 1,
              borderLeft: 10
            },
            '.MuiDataGrid-cell': {
              padding: densityStateStyle(densityState?.value),

              wordBreak: 'break-word',
              textAlign: 'center',
              justifyContent: 'center'
            },
            '.MuiStack-root': {
              '@media (max-width: 750px)': {
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                width: '100%',
                marginTop: '.5em'
              }
            },
            '& .MuiDataGrid-columnHeaderTitle': {
              textOverflow: 'unset',
              overflow: 'unset',
              whiteSpace: 'break-spaces'
            },
            ...rowStateColors
          }}
          checkboxSelection
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          keepNonExistentRowsSelected
          pagination
          sendEmailBase64
          {...props}
          loading={props?.loading || isGeneratingReport}
        />
      </div>
    </div>
  );
}
